export const isAcceptableFailure = (statusCode: number | undefined): boolean =>
	!statusCode || statusCode === 400 || statusCode === 401 || statusCode === 403;
